export default "__VITE_ASSET__af26QPAm__"